import React, { useState, createContext, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./styles/app.sass";

import SignIn from "./screens/SignIn";
import Page from "./components/Page";
import Home from "./screens/Home";
import ProductsDashboard from "./screens/ProductsDashboard";
import NewProduct from "./screens/NewProduct";
import NewAttribute from "./screens/NewAttribute";
import AttributesList from "./screens/AttributesList";
import Orders from "./screens/Orders";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./Firebase/firebaseConfig";
import { getAttributes, getCategories, getCountries, getCurrency, getLocations, getUserRole } from "./Firebase/firebaseDatabase";
import OrderDetails from "./screens/OrderDetails";
import CategoryList from "./screens/CategoryList";
import NewCategory from "./screens/NewCategory";
import SubCategoryList from "./screens/SubCategoryList";
import NewSubCategory from "./screens/NewSubCategory";
import NewSeller from "./screens/NewSeller";
import SellersList from "./screens/SellersList";
import NewCoupon from "./screens/NewCoupon";
import CouponsList from "./screens/CouponsList";
import CreateNotifications from "./screens/CreateNotifications";
import StoreRulesForm from "./screens/StoreRules/StoreRulesForm";
import NewKeyword from "./screens/NewKeyword";
import KeywordsList from "./screens/KeywordsList";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import LoadingIndicator from "./LoadingScreen/LoadingIndicator";
import HomePageCustomiser from "./screens/HomePageCustomiser";
import Banners from "./screens/Banners";
import CreateBanner from "./screens/CreateBanner";
import CollectionList from "./screens/CollectionList";
import NewCollection from "./screens/NewCollection";
import CollectionProductsList from "./screens/CollectionProductsList";
import * as dotenv from 'dotenv'
import PrivateRoute from "./ProtectedRoute";
dotenv.config()
export const GlobalState = createContext();


function App() {

  //loging check states
  const [isLogin, setIsLogin] = useState(false)
  const [loading, setLoading] = useState(true)

  // to handle all click events and after event completion actions
  const [isClicked, setIsClicked] = useState(false)
  const [isActionComplete, setIsActionComplete] = useState(false)

  //  to handle all nested click events after event completion actions in component's child component
  const [isClickedSave, setIsClickedSave] = useState(false)
  const [isClickActionComplete, setIsClickActionComplete] = useState(false)

  // firebase data handling states for attributes data
  const [attributeList, setAttributeList] = useState([])
  const [attributeById, setAttributeById] = useState()

  // show popup dialog handling state
  const [showModalView, setShowModalView] = useState(false) //popup modal view open and close value handling state
  const [showModalViewCountry, setShowModalViewCountry] = useState(false)
  const [showModalViewLocation, setShowModalViewLocation] = useState(false)
  const [showModalViewShippingMethods, setShowModalViewShippingMethods] = useState(false)
  const [showPopup, setShowPopup] = useState(false)

  //product form attributes select popup radio buttons value, if already selected earlier
  const [activeVariationAttr, setActiveVariationAttr] = useState()

  const [homeCustomProducts, setHomeCustomProducts] = useState([])  //home page customiser data list
  const [selectedHomeCustomProducts, setSelectedHomeCustomProducts] = useState([]) //to handle all selected values while selecting from popup
  const [newProductList, setNewProductList] = useState([])   //State to store alll products from firebase but with selected value for home page customiser popup screen checklist

  // collection selected products list checklist handling state
  const [collSelecProdsList, setCollSelecProdsList] = useState([])

  // variations in product form handling states
  const [variationsList, setVariationsList] = useStateWithCallbackLazy([])

  // delete variation ids in edit product form
  const [deletedVarsIds, setDeletedVarsIds] = useState([])

  // attributes color size handling states
  const [attrColor, setAttrColor] = useState()
  const [attrSize, setAttrSize] = useState()

  // push images in product form variations handling state
  const [isPushedImages, setIsPushedImages] = useState(false)

  // order status handling states
  const [orderStatus2, setOrderStatus2] = useState();

  // order filtered list in order list view page handling state 
  const [ordersFilterBy, setOrdersFilterBy] = useStateWithCallbackLazy('')

  // update order confirmation popup handling states
  const [isConfirmUpdateStatus, setIsConfirmUpdateStatus] = useState(false)

  // locations list in store rules handling state
  const [locationsList, setLocationsList] = useState([])
  const [activeEditLocation, setActiveEditLocation] = useState()
  const [showLocationPopup, setShowLocationPopup] = useState(false)
  const [deleteLocationIds, setDeleteLocationIds] = useState([])

  // shipping methods list in store rules handling state
  const [shippingMethodList, setShippingMethodList] = useState([])
  const [activeShippingMethod, setActiveShippingMethod] = useState()
  const [showShippingMethodPopup, setShowShippingMethodPopup] = useState(false)
  const [deleteShippingMethodIds, setDeleteShippingMethodIds] = useState([])

  // keywords list in store rules handling states
  const [keywordsList, setKeywordsList] = useState([])
  const [activeEditKeyword, setActiveEditKeyword] = useState()
  const [showKeywordPopup, setShowKeywordPopup] = useState(false)
  const [deleteKeywordIds, setDeleteKeywordIds] = useState([])

  // keywords options list in edit product form handling state
  const [newKeywordOptnsList, setNewKeywordOptnsList] = useState(["Select a keyword"])

  // countries data in store rules from firebase handling state
  const [countriesList, setCountriesList] = useState([])
  const [activeEditCountry, setActiveEditCountry] = useState()
  const [showCountryPopup, setShowCountryPopup] = useState(false)
  const [deleteCountryIds, setDeleteCountryIds] = useState([])

  // product sku handling state
  const [productSku, setProductSku] = useState()

  // product status handling state
  const [productStatus, setProductStatus] = useState()

  // locations from firebase handling state
  const [allLocations, setAllLocations] = useState()

  // sellers list data from firebase handling state for seller search in seller list page
  const [sellers, setSellers] = useStateWithCallbackLazy()

  // countries from firebase handling state
  const [allCountries, setAllCountries] = useState()

  // categories list data from firebase handling state
  const [categories, setCategories] = useState()

  // form type of product form handling state (like, add, edit, or detail view)
  const [formTypeProduct, setFormTypeProduct] = useState()

  // Global currency handling state
  const [CURRENCY, setCurrency] = useState()

  // user role state
  const [userRole, setUserRole] = useState()

  // OTP validation handling state for notification form
  const [otpValidation, setOtpValidation] = useState('')

  // LogedIn user data handling state
  const [userData, setUserData] = useState([])

  // product status handling state with variation status
  const [notifyVariationList, setNotifyVariationList] = useState(false)


  useEffect(() => {

    // const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        // https://firebase.google.com/docs/reference/js/firebase.User
        const uid = user.uid;
        await getUserRole(uid).then(async (res) => {
          setUserData(res[0])
          setUserRole(res[0]?.role)
          setIsLogin(true)

          getCurrency().then(res => {
            if (res !== undefined && res !== null) {
              setCurrency(res)
            }
          })
          getAttributes(setAttributeList)
          await getLocations().then(list => {
            setAllLocations(list)
          })
          await getCategories().then(list => {
            setCategories(list)
          })
          await getCountries().then(list => {
            setAllCountries(list)
            setLoading(false)
          })

        })

        // ...
      } else {
        // User is signed out
        setLoading(false)

      }
    });

  }, []);

  return (
    <>
      {loading ? <LoadingIndicator /> : <div>
        <Router>
          <Switch>
            <GlobalState.Provider value={{
              isLogin, setIsLogin,
              isClicked, setIsClicked,
              isActionComplete, setIsActionComplete,
              isClickedSave, setIsClickedSave,
              isClickActionComplete, setIsClickActionComplete,

              attributeList,
              attributeById, setAttributeById,
              showPopup, setShowPopup,
              showModalView, setShowModalView,
              showModalViewCountry, setShowModalViewCountry,
              showModalViewLocation, setShowModalViewLocation,
              showModalViewShippingMethods, setShowModalViewShippingMethods,
              activeVariationAttr, setActiveVariationAttr,
              variationsList, setVariationsList,
              deletedVarsIds, setDeletedVarsIds,
              homeCustomProducts, setHomeCustomProducts,
              selectedHomeCustomProducts, setSelectedHomeCustomProducts,
              collSelecProdsList, setCollSelecProdsList,
              newProductList, setNewProductList,
              attrColor, setAttrColor,
              attrSize, setAttrSize,
              isPushedImages, setIsPushedImages,
              orderStatus2, setOrderStatus2,

              locationsList, setLocationsList,
              showLocationPopup, setShowLocationPopup,
              activeEditLocation, setActiveEditLocation,
              deleteLocationIds, setDeleteLocationIds,

              shippingMethodList, setShippingMethodList,
              activeShippingMethod, setActiveShippingMethod,
              showShippingMethodPopup, setShowShippingMethodPopup,
              deleteShippingMethodIds, setDeleteShippingMethodIds,

              keywordsList, setKeywordsList,
              activeEditKeyword, setActiveEditKeyword,
              showKeywordPopup, setShowKeywordPopup,
              deleteKeywordIds, setDeleteKeywordIds,

              countriesList, setCountriesList,
              activeEditCountry, setActiveEditCountry,
              showCountryPopup, setShowCountryPopup,
              deleteCountryIds, setDeleteCountryIds,

              productSku, setProductSku,
              productStatus, setProductStatus,
              formTypeProduct, setFormTypeProduct,
              sellers, setSellers,
              newKeywordOptnsList, setNewKeywordOptnsList,
              isConfirmUpdateStatus, setIsConfirmUpdateStatus,
              ordersFilterBy, setOrdersFilterBy,
              allLocations, categories,
              allCountries, CURRENCY, userRole,
              otpValidation, setOtpValidation,
              userData, setUserData,
              notifyVariationList, setNotifyVariationList,
            }}>
              {
                isLogin ?
                  <>
                    <PrivateRoute
                      exact
                      path="/"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "ACCOUNT EXECUTIVE", "MARKETING EXECUTIVE"]}
                      children={
                        <Page title="Dashboard">
                          <Home />
                        </Page>
                      }
                    />
                    {/* <Route
                      exact
                      path="/"
                      render={() => (
                        <Page title="Dashboard">
                          <Home />
                        </Page>
                      )}
                    /> */}
                    <PrivateRoute
                      exact
                      path="/products/dashboard"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "ACCOUNT EXECUTIVE", "MARKETING EXECUTIVE"]}
                      children={
                        <Page title="Products list">
                          <ProductsDashboard />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/products/add"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "ACCOUNT EXECUTIVE", "MARKETING EXECUTIVE", "MARKETING EXECUTIVE"]}
                      children={
                        <Page title="Create product">
                          <NewProduct />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/products/edit/:id/:id"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "ACCOUNT EXECUTIVE", "MARKETING EXECUTIVE"]}
                      children={
                        <Page backButton={true} title="Edit product">
                          <NewProduct />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path={`/products/details/:id/:id/${decodeURIComponent(window.location.pathname.split("/")[5])}`}
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "ACCOUNT EXECUTIVE", "MARKETING EXECUTIVE"]}
                      children={
                        <Page backButton={true} title={`Product ${decodeURIComponent(window.location.pathname.split("/")[5])} details`}>
                          <NewProduct />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/products/attributes/add"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Create attribute">
                          <NewAttribute />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/products/attribute/:id/edit"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Edit attribute">
                          <NewAttribute />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/products/attributes"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Attribute List">
                          <AttributesList />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/products/keywords/add"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Create keyword">
                          <NewKeyword />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/products/keywords/edit/:id"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Edit keyword">
                          <NewKeyword />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/products/keywords"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Keywords List">
                          <KeywordsList />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/orders"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "ACCOUNT EXECUTIVE", "MARKETING EXECUTIVE"]}
                      children={
                        <Page title="Orders">
                          <Orders />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/order/:id/details"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "ACCOUNT EXECUTIVE", "MARKETING EXECUTIVE"]}
                      children={
                        <Page backButton={true} title={`Order #${window.location.pathname.split("/")[2]}`}>
                          <OrderDetails />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/categories"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Categories" createButton={true} path="/category/add">
                          <CategoryList />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/collections"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Collections" createButton={true} path="/collection/add">
                          <CollectionList />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/collection/add"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Add collection">
                          <NewCollection />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/collection/:id/edit"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Edit collection">
                          <NewCollection />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/collection/:name/:id"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page
                          title={`${decodeURIComponent(window.location.pathname.split("/")[2])} Selected Products`}
                          backButton={true}
                        >
                          <CollectionProductsList />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/category/add"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Add category">
                          <NewCategory />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/category/:id/edit"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Edit category">
                          <NewCategory />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path={`/subCategory/:${decodeURIComponent(window.location.pathname.split("/")[5])}/:id`}
                      // path="/subCategory/:name/:id"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page
                          title="getFromUrl"
                          // title={`Sub-category | ${decodeURIComponent(window.location.pathname.split("/")[2])}`}
                          createButton={true}
                          path="getFromUrl"
                          // path={`/subCategory/${decodeURIComponent(window.location.pathname.split("/")[2])}/${decodeURIComponent(window.location.pathname.split("/")[3])}/add`}
                          backButton={true}
                        >
                          <SubCategoryList />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/subCategory/:name/:id/add"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title={"Add sub-category"}>
                          <NewSubCategory />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/subCategory/:name/:id/:id/edit"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title={"Edit sub-category"}>
                          <NewSubCategory />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/seller/add"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Create seller">
                          <NewSeller />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/seller/:id/edit"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Edit seller">
                          <NewSeller />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/sellers"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Sellers">
                          <SellersList />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/featuredProducts"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "MARKETING EXECUTIVE"]}
                      children={
                        <Page title="Home page customiser">
                          <HomePageCustomiser />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/banners"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "MARKETING EXECUTIVE"]}
                      children={
                        <Page title="Home page banners">
                          <Banners />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/banners/add"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "MARKETING EXECUTIVE"]}
                      children={
                        <Page title="Home page banners">
                          <CreateBanner />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/banners/edit/:id"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "MARKETING EXECUTIVE"]}
                      children={
                        <Page title="Home page banners">
                          <CreateBanner />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/coupon/add"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Create coupons">
                          <NewCoupon />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/coupon/:id/edit"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Edit coupon">
                          <NewCoupon />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/coupons"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER"]}
                      children={
                        <Page title="Coupons">
                          <CouponsList />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/notifications"
                      userRole={userRole}
                      roles={["SUPER ADMIN", "MANAGER", "MARKETING EXECUTIVE"]}
                      children={
                        <Page title="Notification">
                          <CreateNotifications />
                        </Page>
                      }
                    />

                    <PrivateRoute
                      exact
                      path="/storeRules"
                      userRole={userRole}
                      roles={["SUPER ADMIN"]}
                      children={
                        <Page title="Store Rules">
                          <StoreRulesForm />
                        </Page>
                      }
                    />

                  </>
                  :
                  <>
                    <Route exact path="/" render={() => <SignIn />} />
                  </>
              }
            </GlobalState.Provider>

          </Switch>
        </Router>
      </div>
      }
    </>
  );
}

export default App;
